import { render, staticRenderFns } from "./enterpriseScience.vue?vue&type=template&id=cd60e014&scoped=true"
import script from "./enterpriseScience.vue?vue&type=script&lang=js"
export * from "./enterpriseScience.vue?vue&type=script&lang=js"
import style0 from "./enterpriseScience.vue?vue&type=style&index=0&id=cd60e014&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd60e014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd60e014')) {
      api.createRecord('cd60e014', component.options)
    } else {
      api.reload('cd60e014', component.options)
    }
    module.hot.accept("./enterpriseScience.vue?vue&type=template&id=cd60e014&scoped=true", function () {
      api.rerender('cd60e014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/enterpriseScience.vue"
export default component.exports